import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DaoService } from '../servicos/dao.service';
import { EstadoService } from '../servicos/estado.service';

@Component({
  selector: 'app-aceite-termos',
  templateUrl: './aceite-termos.component.html',
  styleUrls: ['./aceite-termos.component.css']
})
export class AceiteTermosComponent implements OnInit {

  constructor(
    private dao: DaoService,
    public est: EstadoService,
    private router: Router
  ) {}

  termoTexto: string = '';
  termoVersao: string = '';
  aceitou: boolean = false;
  carregando: boolean = true;
  processando: boolean = false;
  cpfLogado: string = '';

  ngOnInit() {
    this.cpfLogado = localStorage.getItem('cpf_logado') || '';
    if (!this.cpfLogado) {
      this.router.navigate(['/login']);
      return;
    }
    this.carregarTermos();
  }

  async carregarTermos() {
    try {
      const res = await this.dao.submeter({ cpf: this.cpfLogado }, 'getTermosLgpd', true);
      if (res && res.termos) {
        this.termoTexto = res.termos;
        this.termoVersao = res.versao;
      } else {
        // Sem termos cadastrados, prossegue normalmente
        this.prosseguirFluxo();
        return;
      }
    } catch (err) {
      console.error('Erro ao carregar termos:', err);
      this.dao.toast('e', 'Erro ao carregar os termos. Tente novamente.');
    }
    this.carregando = false;
  }

  async confirmarAceite() {
    if (!this.aceitou) {
      this.dao.toast('e', 'Você precisa aceitar os termos para continuar.');
      return;
    }

    if (this.processando) return;
    this.processando = true;

    try {
      const dados = {
        cpf: this.cpfLogado,
        versao: this.termoVersao
      };
      const res = await this.dao.submeter(dados, 'registrarAceiteLgpd');
      if (res === 'ok' || (res && res.status === 'ok')) {
        this.dao.toast('s', 'Termos aceitos com sucesso!');
        setTimeout(() => {
          this.prosseguirFluxo();
        }, 400);
      } else {
        this.dao.toast('e', 'Erro ao registrar aceite. Tente novamente.');
        this.processando = false;
      }
    } catch (err) {
      console.error('Erro ao registrar aceite:', err);
      this.dao.toast('e', 'Erro ao registrar aceite. Tente novamente.');
      this.processando = false;
    }
  }

  prosseguirFluxo() {
    const destino = localStorage.getItem('lgpd_destino') || '/inicial';
    localStorage.removeItem('lgpd_destino');
    this.router.navigate([destino]);
  }
}
